import { render } from "./Step4.vue?vue&type=template&id=156f61d6&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=ts"
export * from "./Step4.vue?vue&type=script&lang=ts"

import "./Step4.vue?vue&type=style&index=0&id=156f61d6&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-156f61d6"

export default script